// OEO Performance & App Deferral Scripts
// Extracted from theme.liquid — Ella 9 April 2026 (approved Teigan)
// These run inline-equivalent but as an external deferred file
;(function(){

// ── Script 1 ──
(function(){
    (function(){
      var _tidioQueue = [];
      var _origAppendChild = Element.prototype.appendChild;
      var _origInsertBefore = Element.prototype.insertBefore;

      function isTidio(el) {
        return el && el.tagName === 'SCRIPT' &&
          typeof el.src === 'string' && el.src.indexOf('tidio') !== -1;
      }

      function delayTidio(el, fn) {
        if (isTidio(el)) {
          _tidioQueue.push({el: el, fn: fn});
          return el;
        }
        return fn(el);
      }

      Element.prototype.appendChild = function(el) {
        var self = this;
        return delayTidio(el, function(e){ return _origAppendChild.call(self, e); });
      };

      Element.prototype.insertBefore = function(el, ref) {
        var self = this;
        return delayTidio(el, function(e){ return _origInsertBefore.call(self, e, ref); });
      };

      function loadTidio() {
        Element.prototype.appendChild = _origAppendChild;
        Element.prototype.insertBefore = _origInsertBefore;
        _tidioQueue.forEach(function(item){
          item.fn(item.el);
        });
      }

      // Load after 10 seconds OR when user shows intent (scroll/click/touch)
      var _loaded = false;
      function triggerLoad() {
        if (_loaded) return;
        _loaded = true;
        loadTidio();
      }

      setTimeout(triggerLoad, 10000);
      document.addEventListener('scroll', triggerLoad, {once: true, passive: true});
      document.addEventListener('click', triggerLoad, {once: true, passive: true});
      document.addEventListener('touchstart', triggerLoad, {once: true, passive: true});
    })();
    })();

// ── Script 2 ──
(function(){
    (function(){
      // Rise.ai only loads on the gift card product page — restricted by Teigan 31 Mar 2026
      var _isGiftCardPage = window.location.pathname.indexOf('/products/rise-ai-giftcard') !== -1 
                         || window.location.pathname.indexOf('/products/gift') !== -1
                         || document.querySelector('[data-product-handle="rise-ai-giftcard"]') !== null;
      var _isCollectionPage = window.location.pathname.indexOf('/collections/') === 0 || window.location.pathname.indexOf('/collections/') === 1;
      // Defer non-critical 3rd party scripts until first user interaction
      // Falls back to timer if no interaction within budget
      var _isHomepage = window.location.pathname === '/' || window.location.pathname === '';
      var _interactionFired = false;
      var _deferred = [
        // HOMEPAGE: defer all 5 indefinitely (Teigan request 26 Apr 12:23 — not needed on homepage)
        // OTHER PAGES: keep normal deferral so functionality works
        { match: 'swym',     delay: _isHomepage ? 999999 : (_isCollectionPage ? 999999 : 5000) },
        { match: 'loox',     delay: _isHomepage ? 999999 : (_isCollectionPage ? 999999 : 5000) },
        { match: 'klaviyo',  delay: _isHomepage ? 999999 : 4000 },
        { match: 'customily',delay: _isHomepage ? 999999 : 4000 },
        { match: 'rise-ai',  delay: _isGiftCardPage ? 3000 : 999999 },
        { match: 'strn.',    delay: _isGiftCardPage ? 3000 : 999999 },
        { match: 'transcy',  delay: _isHomepage ? 999999 : 2500 }
      ];
      
      // Fire all deferred scripts on first interaction (override delay)
      function _fireOnInteraction() {
        if (_interactionFired) return;
        _interactionFired = true;
        // Trigger all queues immediately
        _queues.forEach(function(q, i) {
          if (q.length > 0) {
            q.forEach(function(item){ try { item.run(); } catch(e){} });
            q.length = 0;
          }
        });
      }
      ['click','touchstart','scroll','mousemove','keydown'].forEach(function(evt){
        window.addEventListener(evt, _fireOnInteraction, { once: true, passive: true });
      });

      var _queues = _deferred.map(function(){ return []; });
      var _origAC = Element.prototype.appendChild;
      var _origIB = Element.prototype.insertBefore;

      function matchIndex(el) {
        if (!el || el.tagName !== 'SCRIPT') return -1;
        var src = el.src || el.getAttribute('src') || '';
        for (var i = 0; i < _deferred.length; i++) {
          if (src.indexOf(_deferred[i].match) !== -1) return i;
        }
        return -1;
      }

      function intercept(origFn, el, extra) {
        var self = this;
        var idx = matchIndex(el);
        if (idx !== -1) {
          _queues[idx].push(function(){
            origFn.call(self, el, extra);
          });
          return el;
        }
        return origFn.call(self, el, extra);
      }

      Element.prototype.appendChild = function(el) {
        return intercept.call(this, _origAC, el);
      };
      Element.prototype.insertBefore = function(el, ref) {
        return intercept.call(this, _origIB, el, ref);
      };

      _deferred.forEach(function(d, i) {
        setTimeout(function(){
          Element.prototype.appendChild = _origAC;
          Element.prototype.insertBefore = _origIB;
          _queues[i].forEach(function(fn){ fn(); });
        }, d.delay);
      });

      // Also trigger all on user interaction
      var _flushed = false;
      function flushAll() {
        if (_flushed) return; _flushed = true;
        Element.prototype.appendChild = _origAC;
        Element.prototype.insertBefore = _origIB;
        // Only flush queues that aren't blocked (delay < 99999)
        _queues.forEach(function(q, i){
          if (_deferred[i] && _deferred[i].delay >= 99999) return; // skip blocked items
          q.forEach(function(fn){ fn(); });
        });
      }
      ['scroll','click','touchstart'].forEach(function(e){
        document.addEventListener(e, flushAll, {once:true, passive:true});
      });
    })();
    })();

// ── Script 3 ──
(function(){
    (function(){
      var _poQ = [];
      var _origAC3 = Element.prototype.appendChild;
      var _origIB3 = Element.prototype.insertBefore;
      function isPushOwl(el) {
        return el && el.tagName === 'SCRIPT' && typeof el.src === 'string' &&
          (el.src.indexOf('pushowl') !== -1 || el.src.indexOf('js-client') !== -1);
      }
      Element.prototype.appendChild = function(el) {
        if (isPushOwl(el)) { var s=this; _poQ.push(function(){_origAC3.call(s,el);}); return el; }
        return _origAC3.call(this, el);
      };
      Element.prototype.insertBefore = function(el, ref) {
        if (isPushOwl(el)) { var s=this,r=ref; _poQ.push(function(){_origIB3.call(s,el,r);}); return el; }
        return _origIB3.call(this, el, ref);
      };
      setTimeout(function(){
        Element.prototype.appendChild = _origAC3;
        Element.prototype.insertBefore = _origIB3;
        _poQ.forEach(function(fn){fn();});
      }, 8000);
    })();
    })();

// ── Script 4 ──
(function(){
    (function(){
      var _origFetch = window.fetch;
      window.fetch = function(input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (url.indexOf('ct.pinterest.com') !== -1 || url.indexOf('pintrk') !== -1) {
          return Promise.resolve(new Response('', {status: 200}));
        }
        return _origFetch.apply(this, arguments);
      };
      var _origXHR = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function(method, url) {
        if (url && (url.indexOf('ct.pinterest.com') !== -1 || url.indexOf('pintrk') !== -1)) {
          this._blocked = true;
        }
        return _origXHR.apply(this, arguments);
      };
      var _origSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.send = function() {
        if (this._blocked) return;
        return _origSend.apply(this, arguments);
      };
    })();
    })();

// ── Script 5 ──
(function(){
    (function(){
      // Only defer on collection, homepage, and blog pages — NOT product/cart pages
      var pageType = (window.location.pathname.indexOf('/collections/') === 0 ? 'collection' : 'other');
      var deferOnPages = ['collection', 'index', 'blog', 'article', 'page'];
      if (deferOnPages.indexOf(pageType) === -1) return; // allow on product/cart

      var _origAC4 = Element.prototype.appendChild;
      var _origIB4 = Element.prototype.insertBefore;
      var _deferred4 = [];

      var deferPatterns = [
        'contactform',
        'customizery',
        'best_custom_product_options',
        'bss-pl',
        'bss_pl',
        // OEO collection page extra deferrals — Ella 2026-03-31
        'loox',           // Reviews app — not needed above fold on collections
        'swymrelay',      // Wishlist — not needed for initial render
        'uppromote',      // Affiliates — not needed for initial render
        'privy',          // Email capture — defer until interaction
        'gorgias',        // Chat — already deferred but belt+suspenders
        'omnisend',       // Email — not needed immediately
        'klaviyo',        // Analytics OK to defer on collections
        'tech-arms',      // BSS Product Options — not needed on collections
        'product-labels', // BSS Labels — not needed on collections
        'bss-pl-config',  // BSS config — block completely on collections
      ];

      // On collections: also defer any script injected after 100ms of load
      // that isn't from shopify CDN or critical OEO scripts
      var strictDeferOnCollections = (pageType === 'collection');

      function shouldDefer(el) {
        if (!el || el.tagName !== 'SCRIPT') return false;
        var src = el.src || '';
        if (deferPatterns.some(function(p){ return src.indexOf(p) !== -1; })) return true;
        // On collection pages: defer any non-Shopify, non-critical script
        if (strictDeferOnCollections && src &&
            src.indexOf('cdn.shopify.com') === -1 &&
            src.indexOf('shopifycdn.com') === -1 &&
            src.indexOf('shopifysvc.com') === -1 &&
            src.indexOf('negate.io') === -1 &&
            src.indexOf('google-analytics') === -1 &&
            src.indexOf('googletagmanager') === -1 &&
            src.indexOf('facebook.net') === -1 &&
            src.indexOf('connect.facebook') === -1) {
          return true;
        }
        return false;
      }

      Element.prototype.appendChild = function(el) {
        if (shouldDefer(el)) {
          var s = this; _deferred4.push(function(){ _origAC4.call(s, el); }); return el;
        }
        return _origAC4.call(this, el);
      };
      Element.prototype.insertBefore = function(el, ref) {
        if (shouldDefer(el)) {
          var s = this, r = ref; _deferred4.push(function(){ _origIB4.call(s, el, r); }); return el;
        }
        return _origIB4.call(this, el, ref);
      };

      // Load after 8s or first user interaction
      var _loaded4 = false;
      function flush() {
        if (_loaded4) return; _loaded4 = true;
        Element.prototype.appendChild = _origAC4;
        Element.prototype.insertBefore = _origIB4;
        _deferred4.forEach(function(fn){ fn(); });
      }
      setTimeout(flush, 8000);
      ['scroll','click','touchstart'].forEach(function(e){
        document.addEventListener(e, flush, {once:true, passive:true});
      });
    })();
    })();

// ── Script 6 ──
(function(){
    // Preserve dataLayer pushes during deferral window
    window.dataLayer = window.dataLayer || [];
    var _dlQueue = [];
    var _origDL = window.dataLayer.push.bind(window.dataLayer);
    window.dataLayer.push = function() {
      _dlQueue.push(arguments);
      return _origDL.apply(this, arguments);
    };
    // Defer gtag network calls until after page load
    function gtag(){dataLayer.push(arguments);}
    window.addEventListener('load', function() {
      // Restore normal dataLayer
      window.dataLayer.push = _origDL;
      // Flush queued items
      _dlQueue.forEach(function(args){ _origDL(args); });
    }, {once: true, passive: true});
    })();

})();